var g = Object.defineProperty;
var f = (e, t, r) => t in e ? g(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var d = (e, t, r) => (f(e, typeof t != "symbol" ? t + "" : t, r), r);
const m = (e, t) => t && t.message ? `${e}(${t.message})` : e;
class h extends Error {
  constructor(t) {
    super(m("ConferenceFinderError", t)), this.cause = t, Object.setPrototypeOf(this, h.prototype);
  }
}
class p extends Error {
  constructor(r) {
    super(m(`NotFoundError: ${r}`));
    d(this, "query");
    this.query = r, Object.setPrototypeOf(this, p.prototype);
  }
}
var a = /* @__PURE__ */ ((e) => (e[e.ED = 0] = "ED", e[e.RC = 1] = "RC", e[e.STAGE = 2] = "STAGE", e[e.LIVE = 3] = "LIVE", e))(a || {});
const l = {
  [a.ED]: {
    meetingFinderService: "https://meetingfinder.services-ed.goto.com"
  },
  [a.RC]: {
    meetingFinderService: "https://meetingfinder.services-rc.goto.com"
  },
  [a.STAGE]: {
    meetingFinderService: "https://meetingfinder.services-stage.goto.com"
  },
  [a.LIVE]: {
    meetingFinderService: "https://meetingfinder.services.goto.com"
  }
}, w = (e) => Math.pow(2, e * 2) * 100, y = (e) => new Promise((t) => {
  setTimeout(() => {
    t();
  }, e);
});
class u extends Error {
  constructor(r, s) {
    super("RetryError");
    d(this, "retryCount");
    this.cause = s, this.retryCount = r, Object.setPrototypeOf(this, u.prototype);
  }
}
const E = async (e, t, r, s) => {
  let i = 0, n;
  for (let c = 0; c <= r; c++) {
    try {
      const o = await e();
      if (!t(o))
        return o;
    } catch (o) {
      n = o;
    }
    if (c < r) {
      const o = w(c);
      await y(o), i++, s == null || s(i, n);
    }
  }
  throw new u(i, n);
}, F = async (e, t) => {
  const r = l[t.environment].meetingFinderService, s = t.fetch || globalThis.fetch, i = t.encodeURIComponent || globalThis.encodeURIComponent;
  try {
    const c = await (await E(
      () => s(`${r}/find?id=${i(e)}`, {
        headers: {
          "accept-header": "application/json",
          "x-client-name": t.clientName
        },
        method: "GET"
      }),
      (o) => o.status !== 200 && o.status !== 404,
      t.retries,
      t.onRetry
    )).json();
    if (c[0])
      return c[0];
    throw new p(e);
  } catch (n) {
    throw new h(n);
  }
};
export {
  h as ConferenceFinderError,
  a as Environments,
  p as NotFoundError,
  F as findConference
};
